import { createContext } from "react";

const MileTransformationContext = createContext(false);

export default MileTransformationContext;
